exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".espacio{margin-bottom:52px}", ""]);

// exports
